import { ChangeEvent, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModal, getWalletBalanceSelector, getWalletLoadingSelector } from 'primsell-shared-layer/features'

import { amountToRedeemSelector, RedeemActions } from 'features'

const useBurnNftModalController = () => {
  const { closeModal } = useModal()
  const dispatch = useDispatch()

  const amountToRedeem = useSelector(amountToRedeemSelector)
  const maxAmount = useSelector(getWalletBalanceSelector)
  const isLoading = useSelector(getWalletLoadingSelector)

  const handleCloseModal = useCallback(() => {
    dispatch(RedeemActions.setAmountToRedeem(1))
  }, [dispatch])

  const handleCancel = useCallback(() => {
    handleCloseModal()
    closeModal()
  }, [handleCloseModal, closeModal])

  const handleChangeAmount = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (+e.target.value >= 0 && +e.target.value <= +maxAmount) {
        dispatch(RedeemActions.setAmountToRedeem(+e.target.value))
      }
    },
    [dispatch, maxAmount]
  )

  const handleAdd = useCallback(() => {
    dispatch(RedeemActions.setAmountToRedeem(amountToRedeem + 1))
  }, [amountToRedeem, dispatch])

  const handleSubtract = useCallback(() => {
    dispatch(RedeemActions.setAmountToRedeem(amountToRedeem - 1))
  }, [amountToRedeem, dispatch])

  const handleMax = useCallback(() => {
    if (+maxAmount > 0) {
      dispatch(RedeemActions.setAmountToRedeem(+maxAmount))
    }
  }, [dispatch, maxAmount])

  return {
    isLoading,
    amountToRedeem,
    maxAmount,
    handleCloseModal,
    handleChangeAmount,
    handleAdd,
    handleSubtract,
    handleMax,
    handleCancel,
  }
}

export { useBurnNftModalController }
